export enum ContactFormValuesTypeEnum {
  MARKETING = 'MARKETING',
  BACKGROUND = 'BACKGROUND',
  CONTACT = 'CONTACT',
}
